module.exports = __webpack_public_path__ + "static/img/faPath1.8d3dc893.gif";